"use client";
import React from "react";

export default function FeaturesCompare({ data }) {
  const {
    title,
    subtitle,
    features = [],
    columns = [],
    background = {},
    align = "center",
  } = data || {};

  const bgStyle =
    background.type === "color"
      ? { backgroundColor: background.value }
      : background.type === "gradient"
        ? { backgroundImage: background.value }
        : background.type === "image"
          ? {
              backgroundImage: `url(${background.value})`,
              backgroundSize: "cover",
              backgroundPosition: "enter",
            }
          : {};

  const textAlign =
    align === "left"
      ? "text-left items-start"
      : align === "right"
        ? "text-right items-end"
        : "text-center items-center";

  return (
    <section className="py-16" style={bgStyle}>
      <div className="max-w-6xl mx-auto px-4">
        <div className={`mb-10 flex flex-col ${textAlign}`}>
          {title && (
            <h2 className="text-3xl font-bold text-foreground">{title}</h2>
          )}
          {subtitle && <p className="text-muted-foreground mt-2">{subtitle}</p>}
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="border px-4 py-2 text-left">Feature</th>
                {columns.map((col, i) => (
                  <th key={i} className="border px-4 py-2 text-center">
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {features.map((row, i) => (
                <tr key={i}>
                  <td className="border px-4 py-2 font-medium">{row.label}</td>
                  {row.values.map((val, j) => (
                    <td key={j} className="border px-4 py-2 text-center">
                      {val === true ? "✅" : val === false ? "❌" : val}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
